import { render } from "./episodeList.vue?vue&type=template&id=843c0d50&bindings={\"episodeList\":\"data\",\"info\":\"data\",\"onClickNavigate\":\"options\"}"
import script from "./episodeList.vue?vue&type=script&lang=js"
export * from "./episodeList.vue?vue&type=script&lang=js"
script.render = render

export default script